import http from './http'

export function getDiscounts(params = {}) {
  return http.get('discount', { params }).then((res) => res.data)
}

export function createDiscount(data) {
  return http.post('discount', data).then((res) => res.data)
}

export function updateDiscount(id, data) {
  return http.put(`discount/${id}`, data).then((res) => res.data)
}

export function deleteDiscount(id) {
  return http.delete(`discount/${id}`).then((res) => res.data)
}
